import { render } from "./FormulasView.vue?vue&type=template&id=23ced891&scoped=true&ts=true"
import script from "./FormulasView.vue?vue&type=script&lang=ts"
export * from "./FormulasView.vue?vue&type=script&lang=ts"

import "./FormulasView.vue?vue&type=style&index=0&id=23ced891&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ced891"]])

export default __exports__